<template>
  <PlaceholderPantalla
    titulo="Reportes de Ventas"
    subtitulo="Análisis y métricas de ventas"
    descripcion="Centro de análisis de ventas con reportes detallados: ventas por período, productos más vendidos, análisis de horarios pico, comparativos, tendencias, estacionalidad, y métricas clave de negocio (ticket promedio, rotación, etc.). Genera insights para optimizar tu operación y aumentar ventas."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Reporte de Ventas Totales por Período',
  'Ventas por Producto/Platillo (ranking)',
  'Ventas por Categoría',
  'Análisis de Ventas por Hora del Día (horas pico)',
  'Análisis de Ventas por Día de la Semana',
  'Comparativo de Ventas (día vs día, mes vs mes)',
  'Tendencias de Ventas con gráficas',
  'Análisis de Estacionalidad',
  'Ticket Promedio y su evolución',
  'Productos Estrella vs Productos de Baja Rotación',
  'Análisis de Descuentos otorgados',
  'Análisis de Cancelaciones',
  'Métodos de Pago preferidos',
  'Propinas promedio',
  'Rotación de Mesas',
  'Tiempo promedio de servicio',
  'Productos que se venden juntos (combos)',
  'Dashboard ejecutivo de ventas',
  'Exportar reportes a Excel/PDF'
]

const datosManejados = [
  'Período de análisis',
  'Tipo de reporte',
  'Filtros aplicados',
  'Total de ventas',
  'Número de tickets',
  'Ticket promedio',
  'Productos vendidos (ranking)',
  'Cantidades por producto',
  'Ventas por categoría',
  'Ventas por hora',
  'Ventas por día de semana',
  'Comparativos históricos',
  'Tendencias y proyecciones',
  'Descuentos totales',
  'Cancelaciones totales',
  'Métodos de pago (desglose)',
  'Propinas totales',
  'Gráficas y visualizaciones',
  'KPIs principales',
  'Formato de exportación'
]
</script>
